import { useState } from "react"
import { ImportXLSX } from "../../../../theme/Component/ImportXLSX"
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _CreditAccount, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { toast } from "react-toastify";

export const ActualizarCartera = () => {

    const instance = useDataBean(_CreditAccount);
    const [data, setData] = useState<any>('');
    const [lista, setLista] = useState<any>([]);
    const [bean, setBean] = useState<any>({});
    const [cant, setCant] = useState<number>(0);

    const loadData = () => {
        // instance.instance.actualizarCartera(cant,JSON.stringify(data)).then(
        //     (resp:any)=>{
        //             setLista(resp);
        //     }
        // )
        instance.instance.recrearCreditoByList(_single.getAccountID(), JSON.stringify(data), ['german.paez@advantage.com.co']).then(
            (resp: any) => {
                setLista(resp);
                toast.success("Se inicio proceso de actualizacion");

            }
        )
    }

    return (
        <div className="row">
            <div className="col-md-6">
                <label>No Registros</label>
                <input type="number" className="form-control" value={cant} onChange={(e) => { setCant(parseInt(e.target.value)) }} />
            </div>
            <div className="col-md-6">
                <ImportXLSX lodaData={setData} />
                <br />
                <BasicButton icon="" eventClick={loadData}>Cargar</BasicButton>
            </div>


        </div>
    )
}